module.exports = function() {
  return new Worker(__webpack_public_path__ + "a26bc3d5bb95fa1858cc.worker.js");
};